import React from 'react'
import { Card, CardContent, Typography, Box, Stack, Button } from '@mui/material'
import { FileUpload as FileUploadIcon, Visibility as ViewIcon, Delete as DeleteIcon } from '@mui/icons-material'

interface AttachmentsPanelProps {
  variant: 'sidebar' | 'mobile'
  selectedFile: File | null
  onFileChange: (file: File | null) => void
  onPreview: () => void
  disabled?: boolean
}

const AttachmentsPanel: React.FC<AttachmentsPanelProps> = ({ variant, selectedFile, onFileChange, onPreview, disabled }) => {
  const inputId = variant === 'sidebar' ? 'file-upload' : 'mobile-file-upload'
  const cardProps = variant === 'sidebar' ? { elevation: 1, sx: { height: '100%' } as const } : { elevation: 1, sx: {} as const }
  // Add bottom padding to extend white area so floating bar doesn't overlap content
  const contentSx = variant === 'sidebar'
    ? { p: 2, pb: 12, height: '100%', display: 'flex', flexDirection: 'column' }
    : { p: 2, pb: 4 }

  return (
    <Card {...cardProps}>
      <CardContent sx={contentSx}>
        <Typography variant="h6" gutterBottom color="primary">
          المرفقات
        </Typography>

        <Box sx={{ 
          border: '2px dashed #ccc', 
          borderRadius: 1, 
          p: 2, 
          textAlign: 'center',
          mb: 2,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          '&:hover': { borderColor: 'primary.main' }
        }}>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files?.[0] || null
              onFileChange(file)
            }}
            style={{ display: 'none' }}
            id={inputId}
            disabled={!!disabled}
          />
          <label htmlFor={inputId}>
            <FileUploadIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
            <Typography variant="body2" color="text.secondary">
              اختر صورة أو اسحبها هنا
            </Typography>
          </label>
        </Box>

        {selectedFile && (
          <Box sx={{ ...(variant === 'sidebar' ? { flexGrow: 1 } : {}), display: 'flex', flexDirection: 'column' }}>
            {variant === 'sidebar' ? (
              <Typography variant="body2" gutterBottom>
                الصورة المرفقة:
              </Typography>
            ) : (
              <Typography variant="body2" gutterBottom>
                الصورة المرفقة:
              </Typography>
            )}
            <Box sx={{ 
              ...(variant === 'mobile' ? { height: 200 } : {}),
              border: '1px solid #e0e0e0', 
              borderRadius: 1, 
              p: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img 
                src={URL.createObjectURL(selectedFile)} 
                alt="Preview"
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '100%',
                  objectFit: 'contain'
                }}
              />
            </Box>
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              <Button
                variant="outlined"
                startIcon={<ViewIcon />}
                size="small"
                onClick={onPreview}
                fullWidth
                disabled={!!disabled}
              >
                عرض
              </Button>
              <Button
                variant="outlined"
                startIcon={<DeleteIcon />}
                size="small"
                color="error"
                onClick={() => onFileChange(null)}
                fullWidth
                disabled={!!disabled}
              >
                حذف
              </Button>
            </Stack>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}

export default AttachmentsPanel
